/**
 * The frontend's junction elements.
 *
 * The junction registry (the chip element each junction subtype displays) lives
 * in @auger/ui (fields/junction/registry), with the elements the package owns
 * (tagging → tag). This file registers the others — they read the app's data.
 */
import { registerJunctionElements } from "@auger/ui/fields/junction/registry"
import FileElement from "@/components/elements/FileElement.vue"

registerJunctionElements({
  attachment: { element: FileElement },
})
